import type { GeometryPadWidgetConfig } from '../geometrypad.model';

export const SINGLE_RIGHT_TRIANGLE_PRESET: GeometryPadWidgetConfig = {
  id: 'single-right-triangle',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { c: 10, a: 6, gamma: 90 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: false },
      label: { coloring: true },
    },
  },
  behavior: {
    interactive: ['t1.point.A', 't1.point.B', 't1.point.C'],
  },
};
